// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"2718e4dd","769":"90b13bd0"}[chunkId] + ".chunk.js";
};